import { ContractEs } from "@edp-models/ES/es-contract.model";
import { Action } from "@ngrx/store";

export enum EContractEsActions {
    GetContractsEs = "[Contract] Get Contracts",
    SetContractsEs = "[Contract] Set Contracts",
    SelectContractEs = "[Contract] Select Contract",
    SelectedContractAPIErrorEs = "[Contract] Get Contract API error",
    ShowContractSelectionEs = "[Contract] Show Contract Selection",
    HideContractSelectionEs = "[Contract] Hide Contract Selection",
    IsSingleContractEs = "[Contract] IsSingle Contract Es",
}

export class GetContractsEs implements Action {
    public readonly type = EContractEsActions.GetContractsEs;
}

export class SetContractsEs implements Action {
    public readonly type = EContractEsActions.SetContractsEs;
    constructor(public payload: ContractEs[]) {}
}

export class SelectContractEs implements Action {
    public readonly type = EContractEsActions.SelectContractEs;
    constructor(public contract: ContractEs) {}
}

export class SelectedContractAPIErrorEs implements Action {
    public readonly type = EContractEsActions.SelectedContractAPIErrorEs;
    constructor(public error: Error) {}
}

export class IsSingleContractEs implements Action {
    public readonly type = EContractEsActions.IsSingleContractEs;
    constructor(public payload: boolean) {}
}

export class ShowContractSelectionEs implements Action {
    public readonly type = EContractEsActions.ShowContractSelectionEs;
}

export class HideContractSelectionEs implements Action {
    public readonly type = EContractEsActions.HideContractSelectionEs;
}

export type ContractEsActions =
    | GetContractsEs
    | SetContractsEs
    | SelectContractEs
    | SelectedContractAPIErrorEs
    | ShowContractSelectionEs
    | HideContractSelectionEs
    | IsSingleContractEs;
